import { storyblokEditable } from "@storyblok/react";

const TextWithSections = ({ blok }) => (
    <div className="wrap">
    <div className="textwithsections-wrap flex inner-wrap"{...storyblokEditable(blok)}>
      <div className="textwithsections-content flex flex-col">
        <h2 className="text-3xl">{blok.subheadline}</h2>
        <div className="textwithsections-img ml-8">
        <img className="hide-mobile pb-4" src={blok.image.filename} alt={blok.image.alt} />

      </div>
        <p>
          {blok.section1}
        </p>
        <p className="pt-3">
          {blok.section2}
        </p>
        <p className="pt-3">
          {blok.section3}
        </p>
        <p className="pt-3">
          {blok.section4}
        </p>
        <p className="pt-3">
          {blok.section5}
        </p>
        {/* <div>
          <button>{blok.button}</button>  
        </div> */}
        
      </div>
      <div className="textwithsections-img ml-8">
        <img className="hide-desktop" src={blok.image.filename} alt={blok.image.alt} />
      </div>
    </div>
    </div>
);

export default TextWithSections; 